export const UNICODE_CHARS = {
  BULLET: '\u2022',
};

export const DEFAULT_INTL_LOCALE = 'en-us';
